"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessfulStripeVerificationUrlParam = exports.SuccessfulStripePaymentUrlParam = exports.PaidCreditMeteredPrices = exports.PaidCreditTestMeteredDiscountPrice = exports.PaidCreditTestDiscountPrice = exports.PaidCreditTestMeteredDefaultPrice = exports.PaidCreditTestDefaultPrice = exports.PaidCreditsForEnterpriseTestProduct = exports.PaidCreditsForEnterpriseProduct = exports.PaidCreditTestProduct = exports.PaidCreditMeteredDiscountPrice = exports.PaidCreditDiscountPrice = exports.PaidCreditMeteredDefaultPrice = exports.PaidCreditDefaultPrice = exports.PaidCreditProduct = void 0;
exports.getPaidCreditPriceInCents = getPaidCreditPriceInCents;
exports.getPaidCreditPriceDisplayInfo = getPaidCreditPriceDisplayInfo;
exports.formatPaidCreditPriceForDisplay = formatPaidCreditPriceForDisplay;
exports.getStripeBillingPortalConfiguration = getStripeBillingPortalConfiguration;
const plan_1 = require("../plan");
const structure_1 = require("./structure");
/**
 * This is the Stripe product for paid credits - it can't be changed easily (look into changing prices instead)
 */
exports.PaidCreditProduct = structure_1.StripeProduct.parse("prod_P57HX1YnUzUpb1");
/**
 * This is a real production price
 *
 * This default price is $0.05 per credit
 */
exports.PaidCreditDefaultPrice = structure_1.StripePrice.parse("price_1OGx2fIjmQUDtkuvf6E6a1fL");
exports.PaidCreditMeteredDefaultPrice = structure_1.StripePrice.parse("price_1SKnyTIjmQUDtkuvhn476eAF"); // Same price, but linked to the v2 ai_credits_used meter
/**
 * This is a real production price, used to discount credits by 20% in some cases
 *
 * This discount price is $0.04 per credit
 */
exports.PaidCreditDiscountPrice = structure_1.StripePrice.parse("price_1RHO1xIjmQUDtkuv2DmZgiKN");
exports.PaidCreditMeteredDiscountPrice = structure_1.StripePrice.parse("price_1SKo0NIjmQUDtkuvFPN5SUvd"); // Same price, but linked to the v2 ai_credits_used meter
/**
 * This product is only available from a "test mode" Stripe client; it's not real
 */
exports.PaidCreditTestProduct = structure_1.StripeProduct.parse("prod_P57GUusBxis8Bc");
/**
 * This product ("Flux Enterprise Copilot Credits (100,000)") was used for manually selling Enterprise copilot credit blocks
 */
exports.PaidCreditsForEnterpriseProduct = structure_1.StripeProduct.parse("prod_QBvUz2MOSsMGIB");
exports.PaidCreditsForEnterpriseTestProduct = structure_1.StripeProduct.parse("prod_RunQUymD21hQem");
/**
 * This price is only available from a "test mode" Stripe client; it's not real
 *
 * This price is $0.05 per credit
 */
exports.PaidCreditTestDefaultPrice = structure_1.StripePrice.parse("price_1OGx1iIjmQUDtkuvGS1N7EMH");
exports.PaidCreditTestMeteredDefaultPrice = structure_1.StripePrice.parse("price_1SKnr4IjmQUDtkuvVTZ12547"); // Same price, but linked to the v2 ai_credits_used meter
/**
 * This price is only available from a "test mode" Stripe client; it's not real
 *
 * This price is $0.04 per credit (discounted)
 */
exports.PaidCreditTestDiscountPrice = structure_1.StripePrice.parse("price_1RHO3bIjmQUDtkuv9fKCmXzC");
exports.PaidCreditTestMeteredDiscountPrice = structure_1.StripePrice.parse("price_1SKns6IjmQUDtkuvIjBX5A5Y"); // Same price, but linked to the v2 ai_credits_used meter
exports.PaidCreditMeteredPrices = [
    exports.PaidCreditMeteredDefaultPrice,
    exports.PaidCreditMeteredDiscountPrice,
    exports.PaidCreditTestMeteredDefaultPrice,
    exports.PaidCreditTestMeteredDiscountPrice,
];
/**
 * Mapping from Stripe price IDs to their price in cents per credit
 *
 * Used for calculating the dollar value of credits burned at different prices
 */
const paidCreditPriceInCentsMap = {
    // Production prices - $0.05 per credit = 5 cents
    [exports.PaidCreditDefaultPrice]: structure_1.AmountInCents.parse(5),
    [exports.PaidCreditMeteredDefaultPrice]: structure_1.AmountInCents.parse(5),
    // Production prices - $0.04 per credit = 4 cents (discounted)
    [exports.PaidCreditDiscountPrice]: structure_1.AmountInCents.parse(4),
    [exports.PaidCreditMeteredDiscountPrice]: structure_1.AmountInCents.parse(4),
    // Test prices - $0.05 per credit = 5 cents
    [exports.PaidCreditTestDefaultPrice]: structure_1.AmountInCents.parse(5),
    [exports.PaidCreditTestMeteredDefaultPrice]: structure_1.AmountInCents.parse(5),
    // Test prices - $0.04 per credit = 4 cents (discounted)
    [exports.PaidCreditTestDiscountPrice]: structure_1.AmountInCents.parse(4),
    [exports.PaidCreditTestMeteredDiscountPrice]: structure_1.AmountInCents.parse(4),
};
/**
 * Get the price in cents for a known Stripe credit price ID
 *
 * @param priceId - The Stripe price ID
 * @returns The price in cents per credit, or undefined if the price is unknown
 */
function getPaidCreditPriceInCents(priceId) {
    return paidCreditPriceInCentsMap[priceId];
}
const paidCreditPriceDisplayMap = {
    // Production prices
    [exports.PaidCreditDefaultPrice]: {
        label: "Standard",
        pricePerCredit: "$0.05",
        isTest: false,
        isMetered: false,
    },
    [exports.PaidCreditMeteredDefaultPrice]: {
        label: "Standard (Metered)",
        pricePerCredit: "$0.05",
        isTest: false,
        isMetered: true,
    },
    [exports.PaidCreditDiscountPrice]: {
        label: "Discount",
        pricePerCredit: "$0.04",
        isTest: false,
        isMetered: false,
    },
    [exports.PaidCreditMeteredDiscountPrice]: {
        label: "Discount (Metered)",
        pricePerCredit: "$0.04",
        isTest: false,
        isMetered: true,
    },
    // Test prices
    [exports.PaidCreditTestDefaultPrice]: {
        label: "Standard (Test)",
        pricePerCredit: "$0.05",
        isTest: true,
        isMetered: false,
    },
    [exports.PaidCreditTestMeteredDefaultPrice]: {
        label: "Standard (Test, Metered)",
        pricePerCredit: "$0.05",
        isTest: true,
        isMetered: true,
    },
    [exports.PaidCreditTestDiscountPrice]: {
        label: "Discount (Test)",
        pricePerCredit: "$0.04",
        isTest: true,
        isMetered: false,
    },
    [exports.PaidCreditTestMeteredDiscountPrice]: {
        label: "Discount (Test, Metered)",
        pricePerCredit: "$0.04",
        isTest: true,
        isMetered: true,
    },
};
/**
 * Get human-readable display information for a Stripe credit price ID
 *
 * @param priceId - The Stripe price ID (e.g., "price_1OGx2fIjmQUDtkuvf6E6a1fL")
 * @returns Display info if the price is known, undefined otherwise
 */
function getPaidCreditPriceDisplayInfo(priceId) {
    return paidCreditPriceDisplayMap[priceId];
}
/**
 * Format a Stripe credit price ID for display in admin tools
 *
 * Returns a human-readable string like "$0.05/credit (Standard)" for known prices,
 * or "Unknown price" for unrecognized price IDs
 *
 * @param priceId - The Stripe price ID, or undefined for legacy entries
 * @returns Formatted display string
 */
function formatPaidCreditPriceForDisplay(priceId) {
    if (!priceId) {
        return "Not tracked (legacy entry)";
    }
    const displayInfo = getPaidCreditPriceDisplayInfo(priceId);
    if (displayInfo) {
        return `${displayInfo.pricePerCredit}/credit (${displayInfo.label})`;
    }
    return "Unknown price";
}
/**
 * URL parameter we attach to the successUrl when creating a Stripe checkout session
 *
 * The value will be the Stripe price ID
 */
exports.SuccessfulStripePaymentUrlParam = "successfulStripePayment";
/**
 * URL parameter we attach to the successUrl when creating a Stripe checkout session
 *
 * The value will be the Stripe price ID
 */
exports.SuccessfulStripeVerificationUrlParam = "sv";
/**
 * Billing portal configuration are varied depending on whether the user is viewing the billing settings of an organization,
 * or their own billing settings, and on what plan epoch the user has
 *
 * Managed by `pnpm cli stripe:manage-billing-portal-configuration`
 *
 * @see packages/cli/src/commands/stripe/manage-billing-portal-configuration.ts
 */
function getStripeBillingPortalConfiguration(type, stripeClientMode = structure_1.StripeClientMode.enum.live) {
    if (stripeClientMode === structure_1.StripeClientMode.enum.test) {
        switch (type) {
            case plan_1.PlanEpoch.enum.from_202410:
                return structure_1.StripeBillingPortalConfiguration.parse("bpc_1QDh9ZIjmQUDtkuvtLNyzrfU");
            case plan_1.PlanEpoch.enum.legacy:
                // Note that the "legacy" plan epoch billing portal ID is represented here by undefined because it is the Stripe account's default
                return undefined;
            case "organization":
                return structure_1.StripeBillingPortalConfiguration.parse("bpc_1QDh9zIjmQUDtkuvMNnkcyjU");
        }
    }
    switch (type) {
        case plan_1.PlanEpoch.enum.from_202410:
            return structure_1.StripeBillingPortalConfiguration.parse("bpc_1QDgPHIjmQUDtkuvtCypvgrz");
        case plan_1.PlanEpoch.enum.legacy:
            // Note that the "legacy" plan epoch billing portal ID is represented here by undefined because it is the Stripe account's default
            return undefined;
        case "organization":
            return structure_1.StripeBillingPortalConfiguration.parse("bpc_1NzMCNIjmQUDtkuv3YfRALNA");
    }
}
//# sourceMappingURL=constants.js.map